<section class="intro" #intro id="ueber-uns">

<!--  <div [classList]="show ? 'headline show' : 'headline'">-->
<!--    <img src="assets/gallery/dart-rock-cafe-tobi-mimi.jpg">-->
<!--    <div>Dart und</div>-->
<!--    <div>Gemütlichkeit</div>-->
<!--  </div>-->

  <div [classList]="show ? 'content show' : 'content'">
    <h1><span>Dart und Gemütlichkeit</span><br>in Lohfelden: Willkommen im Dart Rock Cafè!</h1>
    <p>
      Herzlich Willkommen im Dart Rock Cafè, deinem neuen Lieblingsplatz für großartige Abende und spannende Dart-Matches!
      Ob du Stammgast bist oder zum ersten Mal bei uns reinschaust, hier im Dart-Rock-Cafè bist du immer herzlich willkommen.
    </p>
      <div class="image">
        <picture>
          <source srcset="assets/gallery/dart-rock-cafe-tobi-mimi.webp" type="image/webp">
          <img src="assets/gallery/dart-rock-cafe-tobi-mimi.jpg" alt="Dart Rock Cafe Lohfelden - Kassel">
        </picture>
        <p class="copy">
          DRC by <span>Mimi und Tobi</span>
        </p>
      </div>
    <p>
      Bei uns erwartet dich nicht nur eine gemütliche Atmosphäre und tolle Gesellschaft, sondern auch erstklassige Dart-Action.
      Mit unseren 4 Radikal Dartautomaten und Steeldart-Schreiben,
      bieten wir dir alles, was das Darter-Herz begehrt. Zeig dein Können und genieße die Herausforderung!
      <br><br>
      Unsere Kneipe ist stolz auf ihre 10 Dart-Mannschaften, die regelmäßig trainieren und an
      <a [routerLink]="['/magazin/radikal-dart-turniere-im-dart-rock-cafe-kassel']" [attr.href]="'/magazin/radikal-dart-turniere-im-dart-rock-cafe-kassel'">Online Radikal Dart Turnieren</a> teilnehmen.
      Egal, ob du ein erfahrener Spieler bist oder einfach nur zum Spaß ein paar Pfeile werfen möchtest –
      hier findest du garantiert Anschluss und Spaß.
      <br><br>
      Komm vorbei, lass den Alltag hinter dir und erlebe unvergessliche Abende im Dart-Rock-Cafè. Wir freuen uns auf dich!
      <br><br>
      Dein Dart Rock Cafè Team
    </p>
  </div>
</section>
